const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: '91麻豆免费视频网站采用先进的加密技术与隐私保护机制，确保用户浏览安全，让您安心享受免费视频在线观看体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速播放',
    desc: '全球CDN加速节点覆盖，免费高清视频在线即点即播不缓冲。91在线观看视频网站采用智能码率适配技术，流畅度业界领先。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量资源',
    desc: '数万部91免费在线视频资源，每日持续更新。91免费视频网站涵盖丰富频道分类，满足多元观看需求，更新频率行业领先。',
  },
  {
    icon: 'ri-device-line',
    title: '全平台支持',
    desc: '网页端、iOS客户端、Android客户端全覆盖，在线免费视频网站随时随地访问。多端数据同步，无缝切换观看。',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 text-center mb-2">平台优势</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">为什么选择91麻豆免费视频网站？四大核心优势为您保驾护航</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((f, i) => (
            <div key={i} className="group text-center p-6 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-200">
              <div className="w-14 h-14 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary-500 transition-colors duration-200">
                <i className={`${f.icon} text-primary-600 group-hover:text-white text-2xl transition-colors duration-200`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}